import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';

interface GradientBackgroundProps {
  className?: string;
}

export const GradientBackground: React.FC<GradientBackgroundProps> = ({ className }) => {
  // Détecter si nous sommes sur mobile
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const gradientShift = keyframes`
    0% { background-position: 0% 50%; filter: hue-rotate(0deg) saturate(1.05) contrast(1.05); }
    50% { background-position: 100% 50%; filter: hue-rotate(18deg) saturate(1.05) contrast(1.05); }
    100% { background-position: 0% 50%; filter: hue-rotate(0deg) saturate(1.05) contrast(1.05); }
  `;

  return (
    <Box
      className={`gradient-background ${className || ''}`}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        backgroundColor: '#0b0f1a',
      }}
    >
      {!isMobile && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            opacity: 0.26,
            backgroundImage:
              'radial-gradient(900px circle at 20% 15%, rgba(88,101,242,0.55), transparent 60%),'
              + 'radial-gradient(700px circle at 85% 25%, rgba(0,229,255,0.30), transparent 62%),'
              + 'radial-gradient(850px circle at 40% 85%, rgba(186,104,200,0.28), transparent 64%),'
              + 'linear-gradient(120deg, rgba(14,18,28,1), rgba(0,0,0,1))',
            backgroundSize: '220% 220%',
            animation: `${gradientShift} 50s ease-in-out infinite`,
            willChange: 'background-position, filter',
          }}
        />
      )}
    </Box>
  );
};
